export default __webpack_public_path__ + "src/images/main_exhibition-133503.png";